export const getMarginPct = (margin: number, sales: number) => {
  if (sales < 1) {
    return 0;
  }
  return margin / sales;
};
